export const curry = (func) => {
  const curried = (...args) => {
    if (args.length >= func.length) {
      return func(...args);
    } else {
      return (...args2) => curried(...args.concat(args2));
    }
  };

  return curried;
};
